import React, { useMemo, useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap"
import ProgressBar from "@ramonak/react-progress-bar"

import logoIcon from "../../assets/images/logo-icon.svg"
import searchIcon from "../../assets/images/icons/search-icon.svg"
import downArrowIcon from "../../assets/images/icons/down-arrow-color.svg"
import SearchIcon from "../../assets/images/icons/search.svg"
import Sliders from "../../assets/images/icons/sliders.svg"
import ArrowDown from "../../assets/images/icons/arrow-down.svg"
import GraphStatsDescend from "../../assets/images/icons/graph-stats-descend.svg"
import MoneyBag from "../../assets/images/icons/money-bag.svg"
import MultipleUsers from "../../assets/images/icons/multiple-users.svg"
import ShoppingBasket from "../../assets/images/icons/shopping-basket.svg"
import GraphStats from "../../assets/images/icons/graph-stats.svg"
import TableContainer from "components/Common/TableContainer"
import { getTableSortingHeaderIcon } from "helpers/common"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import CommissionEarnedChart from "pages/Dashboard/WealthPartnerDashboard/CommissionEarnedChart"

const defaultFilters = {
  search: "",
  page: 1,
  created_by: "INVESTOR",
  pageSize: 20,
  timestamp: "",
}
const UserDashboard = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [wealthPartnerOpen, setwealthPartnerOpen] = useState(false)
  const [performerOpen, setPerformeOpen] = useState(false)
  const [referralTrackingOpen, setReferralTrackingOpen] = useState(false)
  const [menu, setMenu] = useState(false)

  const [filters, setFilters] = useState(defaultFilters)
  // const [data, setData] = useState([])

  // const [tableDataOpen, setTableDataOpen] = useState("0")
  // const tabledata = (id) => {
  //   if (tableDataOpen === id) {
  //     setTableDataOpen()
  //   } else {
  //     setTableDataOpen(id)
  //   }
  // }

  const [openRows, setOpenRows] = useState({})

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }))
  }
  const datas = [
    {
      id: 1,
      name: "Rohan Mehra",
      email: "rohan.mehra@prachay.in",
      count: 2,
      amount: "₹6,00,00,000",
      interest: "₹60,000",
      expanded: true,
      details: [
        {
          code: "PCL25ICD005",
          subData: [
            { amount: "₹3,00,00,000", interest: "₹30,000" },
            { amount: "₹2,00,00,000", interest: "₹20,000" },
          ],
        },
        { code: "PCL25ICD006", subData: [] },
      ],
    },
  ]

  const columns = useMemo(() => [
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Name"),
      accessorKey: "name",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "#F0A735",
                color: "#fff",
                minHeight: "20px",
                minWidth: "20px",
                height: "20px",
                width: "20px",
                lineHeight: "20px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                marginRight: "8px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              +
            </div>
            {row?.original.name}
          </div>
        </>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, " Master Agreement"),
      accessorKey: "master_agreement",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <>{row?.original.master_agreement}</>,
    },

    {
      header: ({ column }) => getTableSortingHeaderIcon(column, " Invested"),
      accessorKey: "invested",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <>{row?.original.invested}</>,
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, " Commission Earned"),
      accessorKey: "commission_earned",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <>{row?.original.commission_earned}</>,
    },
  ])
  const data = [
    {
      name: "John Doe",
      master_agreement: "Agreement A",
      invested: "₹ 10,000",
      commission_earned: "₹ 500",
    },
    {
      name: "Jane Smith",
      master_agreement: "Agreement B",
      invested: "₹ 25,000",
      commission_earned: "₹ 1,200",
    },
    {
      name: "Michael Johnson",
      master_agreement: "Agreement C",
      invested: "₹ 7,500",
      commission_earned: "₹ 350",
    },
    {
      name: "Emily Brown",
      master_agreement: "Agreement D",
      invested: "₹ 15,000",
      commission_earned: "₹ 800",
    },
  ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <div className="container-wrapper-box">
                <div className="container-wrapper-left-box">
                  <div className="user-dashboard-card-box">
                    <div className="card-box-wrapper-section">
                      <div className="card-box">
                        <div className="heading-text">
                          <img src={MoneyBag} alt="" />
                          <h5>Total Commission Earned</h5>
                        </div>
                        <div className="amount-section">
                          <h4>₹108,906</h4>
                          <div className="value">
                            <img src={GraphStatsDescend} alt="" />
                            5.2%
                          </div>
                        </div>
                      </div>
                      <div className="card-bottom-section">
                        <p>
                          You can earn <strong>more</strong> this month
                        </p>
                      </div>
                    </div>
                    <div className="card-box-wrapper-section">
                      <div className="card-box">
                        <div className="heading-text">
                          <img src={ShoppingBasket} alt="" />
                          <h5>Total ICD Volume</h5>
                        </div>
                        <div className="amount-section">
                          <h4>₹ 256,740</h4>
                          <div className="value">
                            <img src={GraphStatsDescend} alt="" />
                            3.8%
                          </div>
                        </div>
                      </div>
                      <div className="card-bottom-section">
                        <p>
                          ICD Investment fell by <strong>₹ 10,200</strong> this
                          month
                        </p>
                      </div>
                    </div>
                    <div className="card-box-wrapper-section">
                      <div className="card-box">
                        <div className="heading-text">
                          <img src={MultipleUsers} alt="" />
                          <h5>No. of Clients</h5>
                        </div>
                        <div className="amount-section">
                          <h4>+1,230</h4>
                          <div className="value increase">
                            <img src={GraphStats} alt="" />
                            5.7%
                          </div>
                        </div>
                      </div>
                      <div className="card-bottom-section">
                        <p>
                          Onboarded <strong>65</strong> new clients this month
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="icd-card-wrapper-section">
                    <Swiper
                      modules={[Navigation, Pagination, Autoplay]}
                      spaceBetween={20}
                      navigation={false}
                      pagination={{ clickable: false }}
                      loop={true}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 1 },
                        1024: { slidesPerView: 2 },
                      }}
                    >
                      <SwiperSlide>
                        <div className="icd-card-box wealth-patner-box">
                          <div className="logo-section-wrapper">
                            <div className="logo-image">
                              <img src={logoIcon} alt="" />
                            </div>
                            <h4>ICD-2025-2735</h4>
                          </div>
                          <h5>₹1,00,00,000</h5>
                          <div>
                            <ProgressBar
                              borderRadius="8px"
                              height="8px"
                              baseBgColor="#FFFFFF33"
                              bgColor="#FFFFFF"
                              completed={60}
                              isLabelVisible={false}
                            />
                          </div>
                          <div className="amount-wrapper">
                            <div className="left-box">
                              <p>
                                Total Amt <span>₹ 10,00,00,000</span>
                              </p>
                              <p>
                                ROI <span>12% p.a</span>
                              </p>
                            </div>
                            <div className="right-box">
                              <p>
                                Req. Amt <span>₹ 9,00,00,000</span>
                              </p>
                              <p>
                                Tenure <span>180 Days</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="icd-card-box-second">
                          <div className="logo-section-wrapper">
                            <div className="logo-image">
                              <img src={logoIcon} alt="" />
                            </div>
                            <h4>ICD-2025-2735</h4>
                          </div>
                          <h5>₹1,00,00,000</h5>
                          <div>
                            <ProgressBar
                              borderRadius="8px"
                              height="8px"
                              baseBgColor="#B3B3B333"
                              bgColor="#F0A634"
                              completed={60}
                              isLabelVisible={false}
                            />
                          </div>
                          <div className="amount-wrapper">
                            <div className="left-box">
                              <p>
                                Total Amt <span>₹ 10,00,00,000</span>
                              </p>
                              <p>
                                ROI <span>12% p.a</span>
                              </p>
                            </div>
                            <div className="right-box">
                              <p>
                                Req. Amt <span>₹ 9,00,00,000</span>
                              </p>
                              <p>
                                Tenure <span>180 Days</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                  <div className="table-section-wrapper">
                    <div className="table-top-section">
                      <h6>Company Status</h6>
                      <div className="tab-section wealth-patner-tab"></div>
                      <div className="search-box-wrapp">
                        <div className="search-box-section">
                          <img src={searchIcon} alt="" />
                        </div>
                        <div className="dropdown-section">
                          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle caret size="lg">
                              This Year <img src={downArrowIcon} alt="" />
                            </DropdownToggle>
                            <DropdownMenu
                              style={{
                                minWidth: "auto",
                              }}
                            >
                              <DropdownItem>This Year</DropdownItem>
                              <DropdownItem>This Year</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                        <div className="filter-section">
                          <img src={Sliders} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="dashboard-table-wrapper">
                      <TableContainer
                        filters={filters}
                        setFilters={setFilters}
                        columns={columns}
                        data={data}
                        isGlobalFilter={false}
                        isCustomPageSize={false}
                        isPagination={false}
                        paginationWrapper="dataTables_paginate paging_simple_numbers"
                        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      />
                    </div>

                    <div className="table-container-wrapper-section">
                      <div className="table-header">
                        <div className="name">Name</div>
                        <div className="master-agreement">
                          Master Agreement <img src={ArrowDown} alt="" />
                        </div>
                        <div className="invested">
                          Invested <img src={ArrowDown} alt="" />
                        </div>
                        <div className="commission-earned">
                          Commission Earned <img src={ArrowDown} alt="" />
                        </div>
                      </div>
                      {datas.map((item) => (
                        <div key={item.id} className="table-section">
                          {/* Main Row */}
                          <div
                            className={`table-row ${openRows[item.id] ? "expanded" : ""}`}
                          >
                            <div className="left">
                              <div
                                onClick={() =>
                                  item.details && toggleRow(item.id)
                                }
                              >
                                <div
                                  className={`toggle-icon ${openRows[item.id] ? "open" : "closed"}`}
                                >
                                  {openRows[item.id] ? "-" : "+"}
                                </div>
                              </div>
                              <div className="info">
                                <div className="name">{item.name}</div>
                                <div className="email">{item.email}</div>
                              </div>
                            </div>

                            <div className="count">{item.count}</div>
                            <div className="amount">{item.amount}</div>
                            <div className="interest">{item.interest}</div>
                          </div>

                          {/* Expandable Section */}
                          {item.details && openRows[item.id] && (
                            <div className="expand-section">
                              {item.details.map((d, index) => (
                                <div key={index} className="expand-item">
                                  <div className="expand-header">
                                    <div className="code">{d.code}</div>
                                    <div
                                      className="total"
                                      onClick={() =>
                                        toggleRow(`${item.id}-${index}`)
                                      }
                                    >
                                      ₹ 5,00,00,000
                                      <i
                                        className={`icon-keyboard_arrow_down ${
                                          openRows[`${item.id}-${index}`]
                                            ? "rotate"
                                            : ""
                                        }`}
                                      ></i>
                                    </div>
                                  </div>

                                  {openRows[`${item.id}-${index}`] &&
                                    d.subData.length > 0 && (
                                      <div className="sub-data">
                                        {d.subData.map((s, i) => (
                                          <div key={i} className="sub-row">
                                            <div className="amount">
                                              {s.amount}
                                            </div>
                                            <div className="interest">
                                              {s.interest}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* <div className="">
                      <Accordion open={tableDataOpen} toggle={tabledata}>
                        <AccordionItem>
                          <AccordionHeader targetId="1">
                            Accordion Item 1
                          </AccordionHeader>
                          <AccordionBody accordionId="1">sdasd</AccordionBody>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionHeader targetId="2">
                            Accordion Item 2
                          </AccordionHeader>
                          <AccordionBody accordionId="2">dasd</AccordionBody>
                        </AccordionItem>
                      </Accordion>
                    </div> */}
                  </div>
                  <div className="chart-section-wrapper">
                    <CommissionEarnedChart />
                  </div>
                </div>
                <div className="container-wrapper-right-box">
                  <div className="container-inner-right-box">
                    <div className="filter-section">
                      <h4>Top Performer</h4>
                      <div className="dropdown-section">
                        <Dropdown
                          isOpen={performerOpen}
                          toggle={() => setPerformeOpen(!performerOpen)}
                        >
                          <DropdownToggle size="lg">
                            This Month <img src={downArrowIcon} alt="" />
                          </DropdownToggle>
                          <DropdownMenu
                            style={{
                              minWidth: "auto",
                            }}
                          >
                            <DropdownItem>Last Month</DropdownItem>
                            <DropdownItem>This Month</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="investor-table-wrapper">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#1667AD",
                              }}
                              className="name"
                            >
                              Name
                            </th>
                            <th
                              style={{
                                backgroundColor: "#1C7ED2",
                              }}
                            >
                              <div className="text-center">
                                Total Commission Earned
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Rohan Gupta Pvt. Ltd.</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Aditya Verma Pvt. Ltd.</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Arvind Technologies Ltd.</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Harshad Patel Pvt. Ltd.</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Trident Corp</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Biscon Corp Foundation</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Harshad Corp Ltd.</td>
                            <td>
                              <div className="text-center">₹ 40,000</div>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="company-table-wrapper">
                    <div className="filter-section">
                      <h4>Referral Tracking</h4>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div className="filter-dropdown-section">
                          <Dropdown
                            isOpen={referralTrackingOpen}
                            toggle={() =>
                              setReferralTrackingOpen(!referralTrackingOpen)
                            }
                          >
                            <DropdownToggle size="lg">
                              This Month <img src={downArrowIcon} alt="" />
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem>Last Month</DropdownItem>
                              <DropdownItem>This Month</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                        <div className="filter">
                          <Dropdown
                            isOpen={wealthPartnerOpen}
                            toggle={() =>
                              setwealthPartnerOpen(!wealthPartnerOpen)
                            }
                          >
                            <DropdownToggle size="lg">
                              <img src={Sliders} alt="" />
                            </DropdownToggle>
                            <DropdownMenu>
                              <div className="dropdown-item-section">
                                <div className="input-wrapper">
                                  <img src={SearchIcon} alt="" />
                                  <Input
                                    name="Search"
                                    placeholder="Search"
                                    type="text"
                                  />
                                </div>
                                <div className="filter-reset">
                                  <p>Select All </p>
                                  <p>Clear All </p>
                                </div>
                                <div className="checkbox-section">
                                  <FormGroup check>
                                    <Input type="checkbox" id="Registration" />
                                    <Label htmlFor="Registration" check>
                                      Registration
                                    </Label>
                                  </FormGroup>
                                  <FormGroup check>
                                    <Input type="checkbox" id="Agreement" />
                                    <Label htmlFor="Agreement" check>
                                      Agreement
                                    </Label>
                                  </FormGroup>
                                  <FormGroup check>
                                    <Input type="checkbox" id="Offer" />
                                    <Label htmlFor="Offer" check>
                                      Offer
                                    </Label>
                                  </FormGroup>
                                  <FormGroup check>
                                    <Input type="checkbox" id="Invested" />
                                    <Label htmlFor="Invested" check>
                                      Invested
                                    </Label>
                                  </FormGroup>
                                </div>
                                <div className="bottom-section">
                                  <p className="clos">Close</p>
                                  <p className="done">Done</p>
                                </div>
                              </div>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                    <div className="company-table-details">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#F0A735",
                              }}
                            >
                              Name
                            </th>
                            <th className="name text-center">Status</th>
                            <th className="action text-center">Commission</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Rohan Mehra</td>
                            <td className="text-center"></td>
                            <td className="text-center">-</td>
                          </tr>
                          <tr>
                            <td>Rohan Mehra</td>
                            <td className="text-center"></td>
                            <td className="text-center">₹ 12,00,000</td>
                          </tr>
                          <tr>
                            <td>Rohan Mehra</td>
                            <td className="text-center"></td>
                            <td className="text-center">-</td>
                          </tr>
                          <tr>
                            <td>Rohan Mehra</td>
                            <td className="text-center"></td>
                            <td className="text-center">-</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="summery-filter-details-table">
                    <div className="filter-section">
                      <h4>Referral Tracking</h4>

                      <div className="filter-dropdown-section">
                        <Dropdown isOpen={menu} toggle={() => setMenu(!menu)}>
                          <DropdownToggle size="lg">
                            This Month <img src={downArrowIcon} alt="" />
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Last Month</DropdownItem>
                            <DropdownItem>This Month</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="summery-filter-details">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#414141",
                                color: "#fff",
                              }}
                            >
                              Date
                            </th>
                            <th
                              style={{
                                backgroundColor: "#7C7C7C",
                                color: "#fff",
                              }}
                              className="action text-center"
                            >
                              Name
                            </th>
                            <th
                              style={{
                                backgroundColor: "#9F9F9F",
                                color: "#fff",
                              }}
                              className="action text-center"
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>03-10-2025</td>
                            <td>
                              <div className=" text-center">
                                Rohan Gupta Pvt. Ltd.
                              </div>
                            </td>
                            <td>
                              <div className="amount text-center">
                                ₹ 52,00,000
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>03-10-2025</td>
                            <td>
                              <div className=" text-center">
                                Rohan Gupta Pvt. Ltd.
                              </div>
                            </td>
                            <td>
                              <div className="amount text-center">
                                ₹ 52,00,000
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>03-10-2025</td>
                            <td>
                              <div className=" text-center">
                                Rohan Gupta Pvt. Ltd.
                              </div>
                            </td>
                            <td>
                              <div className="amount text-center">
                                ₹ 52,00,000
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>03-10-2025</td>
                            <td>
                              <div className=" text-center">
                                Rohan Gupta Pvt. Ltd.
                              </div>
                            </td>
                            <td>
                              <div className="amount text-center">
                                ₹ 52,00,000
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserDashboard
